module.exports = __webpack_public_path__ + "img/mastercard-old.17cfe6eb.svg";